class PhoneNumber {
    CodeHandler(phone, phoneCode) {
        if (phoneCode === '+98') {
            return phone[0] === '0' ? phoneCode + phone.substring(1) : phoneCode + phone
        } else {
            return phoneCode + phone
        }
    }
}
export default new PhoneNumber